import loadable from 'components/dynamic-import';

export const ModulesPicker = loadable(() => import('./ModulesPicker'));
